import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import {
	IAssigneeOrganization,
	IAssigneeUser,
} from '@shared/interfaces/selectable-options.interfaces';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/configs/reducers.config';
import { assigneeList } from '@layout/state/layout.selectors';
import { filter, first } from 'rxjs/operators';
import { AssigneeOptionsListComponent } from '@shared/ui-components/au-assignee-select/components/assignee-options-list/assignee-options-list.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'assignee-filter',
	templateUrl: './assignee-filter.component.html',
	styleUrls: ['./assignee-filter.component.scss'],
	imports: [CommonModule, AssigneeOptionsListComponent, AsyncPipe, NgxTolgeeModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssigneeFilterComponent implements ICmmsFilterComponent, OnInit {
	@Input() data: {
		activePage: CmmsPages;
		columnName: string;
		preselectedValue: string[];
	};
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	filterOptions$: Observable<IAssigneeOrganization[]>;

	constructor(private store$: Store<IAppState>) {}

	ngOnInit(): void {
		this.filterOptions$ = this.store$.select(assigneeList);

		this.filterOptions$
			.pipe(
				filter(value => !!value),
				first()
			)
			.subscribe(assignees => {
				// TODO here is mistake in types. filterOptions$ contains organisations not assignees
				this.applyPreselectedValue(assignees);
			});
	}

	selectOption(assignee: IAssigneeUser): void {
		this.filterValueChanged.emit(this.generateFilterValue(assignee));
	}

	private generateFilterValue(assignee: IAssigneeUser): {
		columnName: string;
		label: string;
		data: string[];
	} {
		/* Label should be in specific format that is needed to show it in filter button. */
		return {
			columnName: this.data.columnName,
			label: `${assignee.firstName} ${assignee.lastName}`,
			data: [assignee.psId],
		};
	}

	private applyPreselectedValue(organization: { users: IAssigneeUser[] }[]): void {
		if (this.data.preselectedValue) {
			const assignees = organization.map(o => o.users).flat();

			const preselectedAssignee = assignees.find(assignee => {
				return this.data.preselectedValue[0] === assignee.psId;
			});

			if (preselectedAssignee) {
				this.selectOption(preselectedAssignee);
			}
		}
	}
}
